import React from "react";
import { useTranslation } from "react-i18next";
import { useSetAtom } from "jotai";

import "./TopUpToPlayModal.scss";
import BottomDrawer from "../../BottomDrawer/BottomDrawer";
import { GenericModalProps } from "../../../utils/constants/generic-types";
import PrimaryButtonWithBonusTag from "../../onboarding/PrimaryButtonWithBonusTag/PrimaryButtonWithBonusTag";
import useHprPurchasePlansQuery from "../../../react-query/queries/use-hpr-purchase-plans";
import { HandleTopup } from "../../topup/TopupFlow/types";
import {
  initiateTopupTriggerAtom,
  InitiateTopupTriggers,
} from "../../../jotai/atoms/analytics";
import useHprFiatFormatter from "../../../hooks/useHprFiatFormatter";
import ImageTopUpFiat from "../../../images/top-up-fiat.svg";
import ImageTopUpHpr from "../../../images/top-up-hpr.svg";

interface TopUpToPlayModalProps extends GenericModalProps {
  handleTopup: HandleTopup;
  description?: React.ReactNode;
}

function TopUpToPlayModal({
  onClose,
  isOpen,
  handleTopup,
  description,
}: TopUpToPlayModalProps) {
  const { t } = useTranslation("games");
  const { hasWelcomeBonus } = useHprPurchasePlansQuery();
  const setInitiateTopupTrigger = useSetAtom(initiateTopupTriggerAtom);
  const { isFiatDisplay } = useHprFiatFormatter();

  const goToTopup = () => {
    setInitiateTopupTrigger(InitiateTopupTriggers.TOPUP_TO_PLAY_MODAL);
    handleTopup();
  };

  return (
    <BottomDrawer isOpen={isOpen} onClose={onClose}>
      <div className="topup-to-play-modal">
        <div className="topup-to-play-image-wrap">
          <img
            src={isFiatDisplay ? ImageTopUpFiat : ImageTopUpHpr}
            alt=""
            width={64}
            height={64}
            className="topup-to-play-image"
          />
        </div>
        <h2>{t("top_up_to_play_modal.title")}</h2>
        <p>{description ?? t("top_up_to_play_modal.content")}</p>
        <PrimaryButtonWithBonusTag
          text={
            hasWelcomeBonus
              ? t("top_up_to_play_modal.claim_welcome_bonus")
              : t("top_up_to_play_modal.top_up_wallet")
          }
          onClick={goToTopup}
          showBonusTag={hasWelcomeBonus}
        />
      </div>
    </BottomDrawer>
  );
}

export default TopUpToPlayModal;
